import React, { ReactNode } from 'react';
import cn from 'classnames';

import styles from './pageTitleStyle.module.css';

type Props = {
  children: ReactNode,
};

const PageTitle: React.FC<Props> = ({ children }) => (
  <div className={cn('row', styles.title)}>
    <div className={cn('col-md-12', styles.content)}>{children}</div>
  </div>
);

export default PageTitle;
